import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionFacade } from '@app/store/session';
import { filter, map, tap } from 'rxjs';

export const loggedIn = (): CanActivateFn => {
    return () => {
        const router = inject(Router);
        const sessionFacade = inject(SessionFacade);

        return sessionFacade.loaded$.pipe(
            tap((loaded) => {
                if (loaded === null) {
                    sessionFacade.getSession();
                }
            }),
            filter((loaded) => loaded !== null),
            map((loaded) => {
                return loaded === true ? true : router.createUrlTree(['/', 'auth']);
            }),
        );
    };
};
